import { render } from "./BrandPortfolioRevenueCell.vue?vue&type=template&id=da678efe&scoped=true"
import script from "./BrandPortfolioRevenueCell.vue?vue&type=script&lang=js"
export * from "./BrandPortfolioRevenueCell.vue?vue&type=script&lang=js"

import "./BrandPortfolioRevenueCell.vue?vue&type=style&index=0&id=da678efe&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-da678efe"]])

export default __exports__